module.exports = __webpack_public_path__ + "static/media/001-thumb up.44478620.svg";